import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Button, Modal } from 'react-bootstrap';
import Swal from 'sweetalert2';

const MasterTasks = () => {
  const [masterTasks, setMasterTasks] = useState([]);
  const [form, setForm] = useState({ task: '' });
  const [isEdit, setIsEdit] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const getMasterTasks = () => {
    setIsLoading(true);
    axios.get(`${process.env.REACT_APP_WEB_SERVICES_URL}/admin/get-master-tasks`, {
      withCredentials: true
    })
      .then(res => {
        setMasterTasks(res.data.tasks || []);
        setIsLoading(false);
      })
      .catch(() => setIsLoading(false));
  };

  useEffect(() => {
    getMasterTasks();
  }, []);

  const openAddModal = () => {
    setForm({ task: '' });
    setIsEdit(false);
    setShowModal(true);
    setSelectedId(null);
  };

  const openEditModal = (t) => {
    setForm({ task: t.task });
    setIsEdit(true);
    setShowModal(true);
    setSelectedId(t.id);
  };

  const validateMasterTaskForm = () => {

  if (!form.task?.trim()) {
    Swal.fire({
      icon: 'warning',
      title: 'Validation Error',
      text: 'Please enter a master task name.'
    });
    return false;
  }
  return true;
};

  const saveMasterTask = () => {
      if (!validateMasterTaskForm()) return;

    axios.post(`${process.env.REACT_APP_WEB_SERVICES_URL}/admin/create-master-task`, form, { withCredentials: true })
      .then(res => {
        if (res.data.status) {
          Swal.fire('Success', 'Master task added!', 'success');
          setShowModal(false);
          getMasterTasks();
        }
      })
      .catch(err => Swal.fire('Error', err.message, 'error'));
  };

  const updateMasterTask = () => {


          if (!validateMasterTaskForm()) return;

    axios.post(`${process.env.REACT_APP_WEB_SERVICES_URL}/admin/update-master-task`, { ...form, id: selectedId }, { withCredentials: true })
      .then(res => {
        if (res.data.status) {
          Swal.fire('Success', 'Master task updated!', 'success');
          setShowModal(false);
          getMasterTasks();
        }
      })
      .catch(err => Swal.fire('Error', err.message, 'error'));
  };

  const deleteMasterTask = (id) => {
    Swal.fire({
      title: 'Are you sure?',
      text: 'This will permanently delete the master task.',
      icon: 'warning',
      showCancelButton: true
    }).then(result => {
      if (result.isConfirmed) {
        axios.post(`${process.env.REACT_APP_WEB_SERVICES_URL}/admin/delete-master-task`, { id }, { withCredentials: true })
          .then(res => {
            if (res.data.status) {
              Swal.fire('Deleted!', res.data.message, 'success');
              getMasterTasks();
            }
          })
          .catch(err => Swal.fire('Error', err.message, 'error'));
      }
    });
  };

  return (
    <div className="container-fluid px-4 mt-4">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h3>Master Task List</h3>
        <Button variant="success" onClick={openAddModal}>Add New Master Task</Button>
      </div>
      <table className="table table-bordered table-striped">
        <thead>
          <tr>
            <th>Master Task</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {isLoading ? (
            <tr><td colSpan="2">Loading...</td></tr>
          ) : masterTasks.length === 0 ? (
            <tr><td colSpan="2">No data found.</td></tr>
          ) : (
            masterTasks.map(t => (
              <tr key={t.id}>
                <td>{t.task}</td>
                <td>
                  <Button variant="info" className="me-2" onClick={() => openEditModal(t)}>Edit</Button>
                  <Button variant="danger" onClick={() => deleteMasterTask(t.id)}>Delete</Button>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>

      <Modal show={showModal} onHide={() => setShowModal(false)} backdrop="static">
        <Modal.Header closeButton>
          <Modal.Title>{isEdit ? 'Edit Master Task' : 'Add Master Task'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="mb-3">
            <label className="form-label">Master Task</label>
            <input
              type="text"
              className="form-control"
              value={form.task}
              onChange={(e) => setForm({ ...form, task: e.target.value })}
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>Cancel</Button>
          <Button variant="primary" onClick={isEdit ? updateMasterTask : saveMasterTask}>
            {isEdit ? 'Update' : 'Save'}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default MasterTasks;